// extracted by mini-css-extract-plugin
module.exports = {"logoContainer":"logo-component_logoContainer__3MDIG"};